import 'vanilla-colorful';
import { Behavior } from '@dia-ui/abstract';

/**
 * based on https://github.com/thednp/color-picker
 */
@Behavior('color-picker')
export class ColorPicker {
  element: any;

  // This is called only once, given the `element` that the behavior is attached to.
  constructor(element) {
    this.element = element;

    //this.area = this.element.getAttribute("data-draggable-element-area-selector");
  }

  // This is called any time the associated `element` is appended into the
  // DOM, passed in the `element`
  async connectedCallback(){
    let picker = this.element.ownerDocument.createElement('hex-color-picker'),
        tooltip = this.element.ownerDocument.createElement('dia-tooltip');

    tooltip.style.setProperty('--dia-tooltip-width', 'auto');
    tooltip.style.setProperty('--dia-tooltip-height', 'min-content');
    tooltip.style.setProperty('--dia-tooltip-padding-top', '5px');
    tooltip.style.setProperty('--dia-tooltip-padding-bottom', '5px');
    tooltip.style.setProperty('--dia-tooltip-padding-left', '5px');
    tooltip.style.setProperty('--dia-tooltip-padding-right', '5px');
    tooltip.style.pointerEvents = "none";
    tooltip.style.visibility = "collapse";

    picker.style.cursor = "pointer";
    picker.setAttribute("color", this.element.value);
    picker.addEventListener('color-changed', (event) => {
      // get updated color value
      colorIcon.style.backgroundColor = event.detail.value;

      if (this.element.value !== event.detail.value) {
        this.element.value = event.detail.value;
        this.element.dispatchEvent(new window.Event("change"));
      }
    });

    this.element.ownerDocument.addEventListener("click", (evt) => {
      let targetEl = evt.target; // clicked element
      do {
        if(targetEl === picker) {
          // This is a click inside, does nothing, just return.
          return;
        }
        // Go up the DOM
        targetEl = targetEl.parentNode;
      } while (targetEl);
      // This is a click outside.

      tooltip.style.pointerEvents = "none";
      tooltip.style.visibility = "collapse";
    });

    let colorIcon = this.element.ownerDocument.createElement('i');
    colorIcon.setAttribute("data-icon-before", true);
    colorIcon.style.cursor = "pointer";
    colorIcon.style.width = "30px";
    colorIcon.style.height = "30px";
    colorIcon.style.borderRadius = "100%";
    colorIcon.style.borderWidth = "2px";
    colorIcon.style.borderColor = "#fff";
    colorIcon.style.borderStyle = "solid";
    colorIcon.style.backgroundColor = this.element.value;
    colorIcon.addEventListener("click", (e) => {
      e.stopPropagation();
      e.preventDefault();

      tooltip.style.pointerEvents = "all";
      tooltip.style.visibility = "visible";
    });

    this.element.addEventListener("change", (event) => this.updatePickerAndIcon(picker, colorIcon, event.target.value));
    this.element.addEventListener("keyup", (event) => this.updatePickerAndIcon(picker, colorIcon, event.target.value));
    this.element.addEventListener("paste", (event) => this.updatePickerAndIcon(picker, colorIcon, event.target.value));
    this.element.addEventListener("input", (event) => this.updatePickerAndIcon(picker, colorIcon, event.target.value));

    tooltip.append(picker);
    this.element.parentElement.append(tooltip);

    this.element.setAttribute("data-icon", true);
    this.element.before(colorIcon);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "attributes" && mutation.attributeName === "disabled") {
          this.handleDisabled(colorIcon);
        }
      });

      this.updateValue(picker);
    });

    observer.observe(this.element, { attributes: true });

    this.updateValue(picker);
    this.handleDisabled(colorIcon);
  }

  // This is called any time the associated `element` is removed from the DOM,
  // passed in the `element`.
  disconnectedCallback() {
  }

  // As with custom elements, define which attributes of the associated
  // element that the behavior should react to.
  /*static observedAttributes = [
    'data-draggable-events',
    'data-draggable-selector'
  ];*/

  // This is called any time any of the `observedAttributes` of the associated
  // element have been changed, just like with Custom Elements but with the
  // additional passed in `element`.
  // attributeChangedCallback(attributeName, oldValue, newValue, element) {}

  // There is one additional API, unlike with Custom Elements. If `static
  // awaitElementDefined` is `true`, then the behavior will not be
  // instantiated and connected until its host element is defined and upgraded
  // (that is, if the host element is possibly a custom element, having a
  // hyphen in its name). If the host element has no hyphen in its name, then
  // this does not apply, and the behavior will be created and connected
  // immediately without waiting. If a possibly-custom element is removed
  // before it is defined, then a behavior will not be created and connected
  // at all (waiting will have been canceled).
  static awaitElementDefined = true // Default is false.

  /**
   * updateValue
   * @param picker
   * @private
   */
  private updateValue(picker) {
    picker.dispatchEvent(new CustomEvent("color-changed", {
      detail: {
        value: this.element.getAttribute("data-color-picker-value")
      }
    }));
  }

  /**
   * updatePickerAndIcon
   * @param picker
   * @param colorIcon
   * @param value
   * @private
   */
  private updatePickerAndIcon(picker, colorIcon, value) {
    picker.setAttribute("color", value);
    colorIcon.style.backgroundColor = value;
  }

  /**
   * handleDisabled
   * @private
   */
  private handleDisabled(colorIcon) {
    if (this.element.hasAttribute("disabled")) {
      this.element.style.pointerEvents = "none";
      colorIcon.style.pointerEvents = "none";
    } else {
      this.element.style.pointerEvents = "all";
      colorIcon.style.pointerEvents = "all";
    }
  }
}
